// src/components/study/FocusExitModal.tsx
// =====================================================================
// MODAL DE SAÍDA DO MODO FOCO
// Aviso quando usuário tenta sair antes dos 20 minutos
// =====================================================================

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, X, CheckCircle } from 'lucide-react';
import './FocusExitModal.css';

interface FocusExitModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirmExit: () => void;
    isSavedMode?: boolean;
    isCustomStudy?: boolean;
    isCustomPath?: boolean;
    deckId?: string;
}

const FocusExitModal: React.FC<FocusExitModalProps> = ({
    isOpen,
    onClose,
    onConfirmExit,
    isSavedMode = false,
    isCustomStudy = false,
    isCustomPath = false,
    deckId = ''
}) => {
    const navigate = useNavigate();

    if (!isOpen) return null;

    const handleConfirmExit = () => {
        onClose();
        onConfirmExit();

        // Invalida cache para domínio atualizar ao voltar
        if (deckId) {
            sessionStorage.removeItem(`subdecks_${deckId}`);
        }

        if (isSavedMode || isCustomStudy) {
            navigate('/dashboard');
        } else {
            const backPath = isCustomPath
                ? `/custom-decks/${deckId}/subdecks`
                : `/subdecks/${deckId}`;
            navigate(backPath);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="focus-exit-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-icon warning">
                    <AlertTriangle size={48} strokeWidth={1.5} color="#f59e0b" />
                </div>
                <h2 className="modal-title">Modo Foco Interrompido</h2>

                <p className="modal-message">
                    Se você sair antes dos 20 minutos:
                </p>

                <div className="modal-warning-list">
                    <div className="warning-item">
                        <X size={16} color="#ef4444" strokeWidth={2.5} />
                        Sessão marcada como inválida
                    </div>
                    <div className="warning-item">
                        <X size={16} color="#ef4444" strokeWidth={2.5} />
                        Nenhuma estatística será registrada
                    </div>
                    <div className="warning-item">
                        <X size={16} color="#ef4444" strokeWidth={2.5} />
                        Nenhum progresso será salvo
                    </div>
                </div>

                <div className="modal-actions-focus">
                    <button className="btn-cancel-exit" onClick={onClose}>
                        <CheckCircle size={16} strokeWidth={2} />
                        Continuar Estudando
                    </button>
                    <button className="btn-confirm-exit" onClick={handleConfirmExit}>
                        Sair Mesmo Assim
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FocusExitModal;